export default __webpack_public_path__ + "static/media/HR.43848d2d.png";